import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import Modal from "@/components/modal/Modal";
import { literals } from "@/constants/literals";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "@/constants/constants";
import TerciaryButton from "@/components/buttons/terciary-button/TerciaryButton";

export type DiscardOrderModalProps = {
  closeModalsGroup: () => void;
  closeDiscardModal: () => void;
};

const DiscardOrderModal = ({
  closeModalsGroup,
  closeDiscardModal,
}: DiscardOrderModalProps) => {
  const navigate = useNavigate();

  const discardOrder = () => {
    navigate(`${BASE_URL}/capture`);
  };

  return (
    <Modal title={literals.discardOrder} opened onClose={closeModalsGroup}>
      <div className="w-full grid gap-4">
        <div>
          <p className="text-sm text-ib-pt-color-gray-1000">
            {literals.discardAlert}
          </p>
        </div>
        <PrimaryButton
          colour="red"
          label={literals.discardOrder}
          onClick={discardOrder}
        />
        <TerciaryButton
          colour="red"
          label={literals.cancel}
          onClick={closeDiscardModal}
        />
      </div>
    </Modal>
  );
};

export default DiscardOrderModal;
